import { React, useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import apiService from '../../services/apiServices';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import TopActions from '../actions/TopActions';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Modal from '../actions/Modal';
import Toast from '../actions/Toasts';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import { spacing } from '@mui/system';
import { Bars } from 'react-loader-spinner'

export default function SalariesList() {
  const [salaries, setSalaries] = useState([]);
  const [salaries1, setSalaries1] = useState([]);
  const [modal, setModal] = useState({});
  const [rowId, setRowId] = useState({});
  const alert = { open: false, message: '', variant: '' };
  const [toast, setToast] = useState(alert);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loader, setLoader] = useState(true);

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const months = [
    {no: 1, name: 'Janar'},
    {no: 2, name: 'Shkurt'},
    {no: 3, name: 'Mars'},
    {no: 4, name: 'Prill'},
    {no: 5, name: 'Maj'},
    {no: 6, name: 'Qershor'},
    {no: 7, name: 'Korrik'},
    {no: 8, name: 'Gusht'},
    {no: 9, name: 'Shtator'},
    {no: 10, name: 'Tetor'},
    {no: 11, name: 'Nentor'},
    {no: 12, name: 'Dhjetor'}
  ]

  const getYear = (date) => {
    return new Date(date).getFullYear()
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const getSalariesMonthlyLists = () => {
    apiService()
      .get('salariesmonthlylists')
        .then((response) => {
          if (response.success) {
            let records = response.data;
            records?.map(w => {
              getSalariesForTotal(w.id)
              // getSalariesForTotal(w.id, 'Advances')
            })
            
            setSalaries1(records);
            setLoader(false)
          } else {
            alert('Error:' + response.errorMessage);
          }
        });
  }

  const properties = ['Salary', 'Advances', 'HourSalary', 'Bonus', 'Penalties'];

  const getSalariesForTotal = (id) => {
    apiService().query('getSalariesByListId', `id=${id}`)
        .then((response) => {
            if(response.success) {
              
              properties?.map(prop => {
                  let name = prop+"_"+id
                  setValue(name, calculateTotal(response.data, prop))
                  console.log(name, calculateTotal(response.data, prop))
              })
              
            }
        })
  }

  const setTotal = (id) => {
    let s = watch("Salary_" + id) ? parseFloat(watch("Salary_" + id)) : 0
    let a = watch("Advances_" + id) ? parseFloat(watch("Advances_" + id)) : 0
    let hs = watch("HourSalary_" + id) ? parseFloat(watch("HourSalary_" + id)) : 0
    let b = watch("Bonus_" + id) ? parseFloat(watch("Bonus_" + id)) : 0
    let p = watch("Penalties_" + id) ? parseFloat(watch("Penalties_" + id)) : 0
    setValue('Total',  s + hs + b - a - p)
    return s + hs + b - a - p
  }
  
  useEffect(() => {
    apiService()
      .get('salaries')
      .then((response) => {
        if (response.success) {
          setSalaries(response.data);
          let products = response.data;
          //grupBy(products)
          setLoader(false)
        } else {
          //alert('Error:' + response.errorMessage);
        }
      });
      getSalariesMonthlyLists()
  }, []);

  const grupBy = (products) => {
    const groupByCategory = products.reduce((group, product) => {
      const { Month } = product;
      var key = months.find(m => m.no == product.Month)?.name + ', ' + new Date(product.SalaryDate).getFullYear();
      group[key] = group[key] ?? [];
      group[key].push(product);
      return group;
    }, {});
    setSalaries1(groupByCategory)
  }

  const calculateTotal = (items, prop) => {
    return parseFloat(items?.reduce((accumulator, current) => parseFloat(accumulator) + current[prop], 0)).toFixed(2)
  }

  const handleDelete = (id) => {
    apiService()
      .delete('salariesmonthlylists', id)
      .then((response) => {
        if (response) {
          setModal({ open: false });
          setToast({
            open: true,
            message: 'U fshi me sukses!',
            variant: 'success',
          });
          setSalaries1(salaries1.filter((salary) => salary.id !== id));
        } else {
          setModal({ open: false });
          setToast({
            open: true,
            message: 'Ka ndodhur nje gabim!',
            variant: 'error',
          });
        }
      });
  };

  const openModal = (id) => {
    setModal({
      open: true,
      tittle: 'Delete',
      message: 'Do you want to delete this row?',
    });
    setToast({ open: false });
    setRowId(id);
  };

  

  //console.log(workers);
  return (
    <div>
      {loader && <div className="loader-class"><Bars
        height="70"
        width="100%"
        color="#1976d2"
        ariaLabel="bars-loading"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
      /></div>}
      {!loader && <>
      <Modal {...modal} handleDelete={() => handleDelete(rowId)} />
      <Toast {...toast} />
      <TopActions newHref="/salarieslist/addlist" saveHref="/dashboard/" />



      <TableContainer component={Paper}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell>Nr</TableCell>
              {/* <TableCell>Emri</TableCell>
              <TableCell>Mbiemri</TableCell> */}
              <TableCell>Muaji</TableCell>
              <TableCell>Viti</TableCell>
              <TableCell>Pagat</TableCell>
              <TableCell>Avanci</TableCell>
              <TableCell>Totali</TableCell>
              <TableCell style={{width: '50px'}}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {salaries1?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((w, index) => (
                <TableRow key={w.id}>
                  <TableCell>{index + 1}</TableCell>
                  {/* <TableCell>{w}</TableCell>
                  <TableCell>{w.LastName}</TableCell> */}
                  <TableCell>{months.find(m => m.no === w.month).name}</TableCell>
                  <TableCell>{w.year}</TableCell>
                  {/* <TableCell>
                    <Moment format="DD/MM/YYYY">{w.createdAt}</Moment>
                  </TableCell> */}
                  <TableCell>
                    {new Intl.NumberFormat('en-GB', {
                      style: 'currency',
                      currency: 'EUR',
                    }).format(watch('Salary_'+w.id))}
                  </TableCell>
                  <TableCell> {watch('Advances_'+w.id)}</TableCell> 
                  <TableCell>{setTotal(w.id)}</TableCell>
                  <TableCell>
                    <ButtonGroup size="small">
                      <Link to={`salarieslist/editlist/${w.id}`}>
                        <Button>
                          <EditIcon />
                        </Button>
                      </Link>
                      <Button onClick={() => openModal(w.id)}>
                        <DeleteIcon />
                      </Button>
                    </ButtonGroup>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={salaries1.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />



{/* <TableContainer component={Paper}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell>Nr</TableCell>
              <TableCell>Muaji</TableCell>
              <TableCell>Data</TableCell>
              <TableCell>Pagat</TableCell>
              <TableCell>Avanci</TableCell>
              <TableCell>Totali</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(salaries1).map(([w, value], index) => (
                <TableRow key={w.Id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{w}</TableCell>
                  <TableCell>
                    <Moment format="DD/MM/YYYY">{w.SalaryDate}</Moment>
                  </TableCell>
                  <TableCell>
                    {new Intl.NumberFormat('en-GB', {
                      style: 'currency',
                      currency: 'EUR',
                    }).format(calculateTotal(value, 'Salary'))}
                  </TableCell>
                  <TableCell>{calculateTotal(value, 'Advances')}</TableCell>
                  <TableCell>
                    <ButtonGroup size="small">
                      <Link to={`salarieslist/monthlist/${getYear(value[0].SalaryDate)}/${value[0].Month}`}>
                        <Button>
                          <EditIcon />
                        </Button>
                      </Link>
                      <Button onClick={() => openModal(w.Id)}>
                        <DeleteIcon />
                      </Button>
                    </ButtonGroup>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={salaries1.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      /> */}



      {/* <TableContainer component={Paper}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell>Nr</TableCell>
              <TableCell>Emri</TableCell>
              <TableCell>Mbiemri</TableCell>
              <TableCell>Muaji</TableCell>
              <TableCell>Data</TableCell>
              <TableCell>Paga</TableCell>
              <TableCell>Avanci</TableCell>
              <TableCell>Totali</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {salaries
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((w, index) => (
                <TableRow key={w.Id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{w.FirstName}</TableCell>
                  <TableCell>{w.LastName}</TableCell>
                  <TableCell>{w.Month}</TableCell>
                  <TableCell>
                    <Moment format="DD/MM/YYYY">{w.SalaryDate}</Moment>
                  </TableCell>
                  <TableCell>
                    {new Intl.NumberFormat('en-GB', {
                      style: 'currency',
                      currency: 'EUR',
                    }).format(w.Salary)}
                  </TableCell>
                  <TableCell>{w.Advances}</TableCell>
                  <TableCell>
                    <ButtonGroup size="small">
                      <Link to={`salarieslist/editsalary/${w.Id}`}>
                        <Button>
                          <EditIcon />
                        </Button>
                      </Link>
                      <Button onClick={() => openModal(w.Id)}>
                        <DeleteIcon />
                      </Button>
                    </ButtonGroup>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={salaries.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      /> */}
      </>}
    </div>
  );
}
